var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-card u-padding-xsmall"},[_c('Tabs',{attrs:{"with-route":"","tabs":_vm.tabs},scopedSlots:_vm._u([{key:"permissions",fn:function(){return [_c('CyclePermissions',{attrs:{"cycle":_vm.cycle}})]},proxy:true},{key:"changedLogs",fn:function(){return [_c('CycleChangedLogs',{attrs:{"cycle":_vm.cycle}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }